module.exports = __webpack_public_path__ + "img/re_IMG_1234.e6a0bd50.jpeg";